// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"867d5b5d","179":"64342b8d","207":"4962f2f1","330":"05ddc43c","594":"61ed2704"}[chunkId] + ".js";
};